import {
  Box,
  Stack,
  Divider,
  Grid,
  InputLabel,
  Typography,
  Checkbox,
  TextField,
  Autocomplete,
  InputAdornment,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import { DateRangePicker, ToolTipWrapper } from 'common/components';
import dayjs from 'dayjs';
import { IOSSwitch } from 'common/components/switch';
import { useDispatch, useSelector } from 'react-redux';
import { MyTeamProfilePopUpFilter } from 'TAP/redux/actions/UserProfileActions/myTeamProfileAction';
import {
  FUNCTION,
  ORGANIZATION,
  ROLE,
  SPECIALIZATION,
  SUB_FUNCTION,
  SUB_SPECIALIZATION,
  DATE,
  labels,
  INPUT_FILD_WWID_REGEX,
  INPUT_FIELD_TEXT_AREA_OTHER_VAL_REGEX,
  ADHOCCURRICULA,
  ADDITIONALOPTIONALCURRICULLA,
  NUMBER_ARRAY,
} from 'common/global/constants';
import { RedTheme } from 'common/global';
import { fontWeightStyles } from 'TAP/styles/genericStyles/fontWeights';
import { Toaster } from '../Toaster';
import { TapGlobalMessages } from 'TAP/global';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { GenericCustomTextArea } from './GenericCustomTextArea';
import SearchIcon from '@material-ui/icons/Search';
import { SingleDatePicker } from 'common/components/SingleDatePicker';
import { GenericAutoCompleteUserProfile } from './GenericAutoCompleteUserProfile';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const MyTeamProfilePopUpUserProfile = ({ params, saveCallBack }) => {
  const NO_DATA_DAS = `-`;
  const NOTAPPLICABLE = 'Not Applicable';
  const notApplicableObj = { id: 'notapplicable', name: NOTAPPLICABLE };
  const OTHER = 'Other';
  const dispatch = useDispatch();
  const theme = RedTheme;
  const filterRecord = useSelector((state) => state?.myTeamProfileRd?.filterData?.data);
  const [isDatePickerShow, setIsDatePickerShow] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState('');
  const [isSelectedOrganizationDirty, setSelectedOrganizationDirty] = useState(false);
  const [selectedFunction, setSelectedFunction] = useState('');
  const [selectedSubFunction, setSelectedSubFunction] = useState('');
  const [selectedSpecialization, setSelectedSpecialization] = useState('');
  const [selectedSubSpecialization, setSelectedSubSpecialization] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedAddnlOptionalCurriculla, setSelectedAddnlOptionalCurriculla] = useState([]);
  const [disableObj, setDisableObj] = useState({
    function: false,
    subFunction: false,
    specialization: false,
    subspecialization: false,
    role: false,
    WWIDMerger: false,
    additionalOptionalCurricula: false,
    additionalInformation: false,
  });
  const [changedDropdownName, setChangedDropdownName] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState([]);
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [otherText, setOtherText] = useState('');
  const [remarkDescription, setRemarkDescription] = useState('');
  const [inputRemarkError, setInputRemarkError] = useState(false);
  const [isWWIDMergerChecked, setIsWWIDMergerChecked] = useState(false);
  const [otherAdditionalImformation, setOtherAdditionalImformation] = useState(false);
  const [oldWWID, setOldWWID] = useState(NUMBER_ARRAY.zero);
  const [inputOldWWIDError, setInputOldWWIDError] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [selectedstartDate, setSelectedStartDate] = useState(null);
  const [isAdhocCurriculaSwitchOn, setIsAdhocCurriculaSwitchOn] = useState(true);
  const [adhocCurricullaChecked, setAdhocCurricullaChecked] = useState(false);
  const [isAdditonalOptionalCurriculaSwitchOn, setIsAdditonalOptionalCurriculaSwitchOn] =
    useState(true);
  const [additionalOptionalCurricullaChecked, setAdditionalOptionalCurricullaChecked] =
    useState(false);

  const labelTypoGraphyStyle = {
    fontSize: '14px',
    fontFamily: '"JohnsonText-Medium"',
    fontStyle: 'normal',
    fontWeight: fontWeightStyles.fw5.fontWeight,
    color: theme.palette.text.lightCaption,
  };
  const labelDataStyle = {
    fontFamily: '"JohnsonText-Regular"',
    fontWeight: fontWeightStyles.fw4.fontWeight,
    color: theme.palette.text.base,
  };
  const inputLabelStyle = {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: '"JohnsonText-Regular"',
    height: screen.isTablet ? '22px' : '16px',
    paddingTop: screen.isTablet ? '3px' : NUMBER_ARRAY.zero,
    lineHeight: 'unset',
  };
  const dropdownFocusedTypesSet = [FUNCTION, SUB_FUNCTION, SPECIALIZATION, SUB_SPECIALIZATION];
  const confirmAutoCompleteSingleSelectionSelectedvalue = (
    selectedValue,
    type,
    selectedOrganization,
  ) => {
    return (
      selectedValue === '' &&
      dropdownFocusedTypesSet.indexOf(type) > NUMBER_ARRAY.zero &&
      selectedOrganization !== '' &&
      !isSelectedOrganizationDirty &&
      !isOtherSelected
    );
  };

  /** Auto Complete component */
  const autoCompleteSingleSelection = (
    autoCompleteOptions,
    selectedValue,
    type,
    label,
    isDisabled = false,
  ) => {
    const options =
      type !== ORGANIZATION
        ? addValuesDropdown(autoCompleteOptions, type, true)
        : autoCompleteOptions;
    selectedValue =
      selectedValue !== ''
        ? getSelectedValueObjectFromList(selectedValue, type)
        : confirmAutoCompleteSingleSelectionSelectedvalue(selectedValue, type, selectedOrganization)
        ? notApplicableObj
        : selectedValue === '' &&
          dropdownFocusedTypesSet.indexOf(type) > NUMBER_ARRAY.zero &&
          options?.filter((item) => item.name !== OTHER && item.name !== NOTAPPLICABLE)?.length ===
            NUMBER_ARRAY.zero
        ? notApplicableObj
        : '';
    return (
      <Fragment>
        <Autocomplete
          id={type}
          getOptionDisabled={(option) => option?.name === NOTAPPLICABLE}
          className={type}
          options={options}
          popupIcon={''}
          autoFocus={false}
          getOptionLabel={(option) => {
            return option?.name || '';
          }}
          value={selectedValue}
          noOptionsText={'No match found'}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          disabled={isDisabled}
          onChange={(event, value) => handleAutoCompleteChange(event, value, type)}
          onInputChange={(event, value, reason) =>
            onChangeAutoCompleteFilter(event, value, reason, type)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                shrink: 'true',
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon sx={isDisabled ? 'theme.palette.fontColor.light_gray' : ''} />
                  </InputAdornment>
                ),
              }}
              placeholder={'Search'}
              label={
                <Stack display={'flex'} flexDirection={'row'} gap={'10px'}>
                  <Typography
                    sx={{
                      ...inputLabelStyle,
                      color: isDisabled
                        ? theme.palette.fontColor.light_gray
                        : theme.palette.text.primary,
                    }}
                  >
                    {isDisabled ? `${label}` : `${label}*`}
                  </Typography>
                  {type === ROLE ||
                    (isDisabled && dropdownFocusedTypesSet.indexOf(type) > NUMBER_ARRAY.zero ? (
                      <></>
                    ) : (
                      <Stack>{genericHelpIcon(getHelperTitle(type), isDisabled)}</Stack>
                    ))}
                </Stack>
              }
              sx={{
                borderBottom: `1px solid ${theme.palette.fontColor.gray_orange}`,
              }}
              variant='standard'
              margin='normal'
            />
          )}
          sx={{
            '& .MuiInputBase-root.Mui-disabled::before': {
              borderColor: theme.palette.fontColor.light_gray,
            },
            mr: 2,
            width: '100%',
          }}
          clearOnBlur
        />
      </Fragment>
    );
  };

  const onChangeAutoCompleteFilter = (_event, value, reason, type) => {
    if (_event) {
      if (type === ORGANIZATION && value) {
        setSelectedOrganization(value.name);
        setSelectedOrganizationDirty(true);
      } else if (type === FUNCTION && value) {
        setSelectedFunction(value.name);
        setSelectedOrganizationDirty(true);
      } else if (type === SUB_FUNCTION && value) {
        setSelectedSubFunction(value.name);
        setSelectedOrganizationDirty(true);
      } else if (type === SPECIALIZATION && value) {
        setSelectedSpecialization(value.name);
        setSelectedOrganizationDirty(true);
      } else if (type === SUB_SPECIALIZATION && value) {
        setSelectedSubSpecialization(value.name);
        setSelectedOrganizationDirty(true);
      } else if (type === ROLE && value) {
        setSelectedRole(value.name);
      } else {
        // no logic
      }
    }
    if (reason.toLowerCase() === 'clear') {
      if (type === ORGANIZATION && value === '') {
        setSelectedOrganization('');
        setSelectedOrganizationDirty(true);
      } else if (type === FUNCTION && value === '') {
        setSelectedFunction('');
        disableLogicForOtherType(value, type);
        setSelectedOrganizationDirty(true);
      } else if (type === SUB_FUNCTION && value === '') {
        setSelectedSubFunction('');
        disableLogicForOtherType(value, type);
        setSelectedOrganizationDirty(true);
      } else if (type === SPECIALIZATION && value === '') {
        setSelectedSpecialization('');
        disableLogicForOtherType(value, type);
        setSelectedOrganizationDirty(true);
      } else if (type === SUB_SPECIALIZATION && value === '') {
        setSelectedSubSpecialization('');
        disableLogicForOtherType(value, type);
        setSelectedOrganizationDirty(true);
      } else if (type === ROLE && value === '') {
        setSelectedRole('');
      }
    }
  };

  /**
   * @description Handle dropdown value changes
   * @param {*} _event
   * @param {*} newValue
   * @param {*} type
   * @returns
   */
  const handleAutoCompleteChange = (_event, newValue, type) => {
    if (!_event || !newValue || newValue === null || newValue === '') return;
    switch (type) {
      case ORGANIZATION:
        setSelectedOrganization(newValue.name);
        resetDependentDropdownValue(type);
        disableLogicForOtherType(newValue.name, type);
        setChangedDropdownName(type);
        otherStatus(newValue.name);
        break;
      case FUNCTION:
        setSelectedFunction(newValue.name);
        resetDependentDropdownValue(type);
        disableLogicForOtherType(newValue.name, type);
        setChangedDropdownName(type);
        otherStatus(newValue.name);
        break;
      case SUB_FUNCTION:
        setSelectedSubFunction(newValue.name);
        resetDependentDropdownValue(type);
        disableLogicForOtherType(newValue.name, type);
        setChangedDropdownName(type);
        otherStatus(newValue.name);
        break;
      case SPECIALIZATION:
        setSelectedSpecialization(newValue.name);
        resetDependentDropdownValue(type);
        disableLogicForOtherType(newValue.name, type);
        setChangedDropdownName(type);
        otherStatus(newValue.name);
        break;
      case SUB_SPECIALIZATION:
        setSelectedSubSpecialization(newValue.name);
        resetDependentDropdownValue(type);
        disableLogicForOtherType(newValue.name, type);
        setChangedDropdownName(type);
        otherStatus(newValue.name);
        break;
      case ROLE:
        setSelectedRole(newValue.name);
        resetDependentDropdownValue(type);
        disableLogicForOtherType(newValue.name, type);
        setChangedDropdownName(type);
        break;
      case ADDITIONALOPTIONALCURRICULLA:
        setSelectedAddnlOptionalCurriculla(newValue);
        setChangedDropdownName(type);
        break;
      default:
        break;
    }
  };
  /**
   * @description helper title according to type
   * @param {*} type
   * @returns
   */
  const getHelperTitle = (type) => {
    let title = '';
    switch (type) {
      case ORGANIZATION:
        title = TapGlobalMessages?.userGroupProfile?.myProfile?.toolTip?.organization;
        break;
      case FUNCTION:
        title = TapGlobalMessages?.userGroupProfile?.myProfile?.toolTip?.function;
        break;
      case SUB_FUNCTION:
        title = TapGlobalMessages?.userGroupProfile?.myProfile?.toolTip?.subFunction;
        break;
      case SPECIALIZATION:
        title = TapGlobalMessages?.userGroupProfile?.myProfile?.toolTip?.specialization;
        break;
      case SUB_SPECIALIZATION:
        title = TapGlobalMessages?.userGroupProfile?.myProfile?.toolTip?.subSpecialization;
        break;
      default:
        break;
    }
    return title;
  };

  const genericHelpIcon = (title, isDisabled = false, height = '12px', width = '12px') => {
    return (
      <ToolTipWrapper
        title={title}
        placement='top-start'
        isOnlyText={true}
        isCustomHtmlTooltip={true}
        tooltipCss={{
          padding: '4px 8px',
        }}
      >
        <HelpOutlineIcon
          fontSize='medium'
          sx={{
            color: isDisabled
              ? `${theme.palette.fontColor.light_gray}`
              : `${theme.palette.common.primaryMainBlue}`,
            height: height,
            width: width,
          }}
        />
      </ToolTipWrapper>
    );
  };

  const createFilterPayload = (
    selectedOrganization,
    selectedFunction,
    selectedSubFunction,
    selectedSpecialization,
    selectedSubSpecialization,
    selectedRole,
  ) => {
    return {
      organization: selectedOrganization === NOTAPPLICABLE ? '' : selectedOrganization,
      function: selectedFunction === NOTAPPLICABLE ? '' : selectedFunction,
      sub_function: selectedSubFunction === NOTAPPLICABLE ? '' : selectedSubFunction,
      specialization: selectedSpecialization === NOTAPPLICABLE ? '' : selectedSpecialization,
      sub_specialization:
        selectedSubSpecialization === NOTAPPLICABLE ? '' : selectedSubSpecialization,
      role: selectedRole === NOTAPPLICABLE ? '' : selectedRole,
    };
  };

  const otherStatus = (value) => {
    if (value === OTHER) {
      setIsOtherSelected(true);
      setOtherText(OTHER);
    } else {
      setOtherText('');
      setIsOtherSelected(false);
    }
  };

  const createSavePopUpPayload = () => {
    return {
      wwid: '',
      organization: selectedOrganization,
      Function: selectedFunction === NOTAPPLICABLE ? '' : selectedFunction,
      sub_function: selectedSubFunction === NOTAPPLICABLE ? '' : selectedSubFunction,
      specialization: selectedSpecialization === NOTAPPLICABLE ? '' : selectedSpecialization,
      sub_specialization:
        selectedSubSpecialization === NOTAPPLICABLE ? '' : selectedSubSpecialization,
      job_role: selectedRole,
      addnl_optional: selectedAddnlOptionalCurriculla,
      leave_of_absence: isDatePickerShow ? 'Y' : 'N', // Leave of Absence as 'Y' or 'N'
      leave_start_date: selectedDateRange[0], // Leave start date in dd mmm yyyy format
      leave_end_date: selectedDateRange[1], // Leave end date in dd mmm yyyy format
      status_type: otherText, // Normally It would be null , if other case is chosen then it'll have value 'other'
      start_date: startDate,
      old_wwid: oldWWID,
      remarks: remarkDescription,
      createdByName: '',
      createdById: '',
    };
  };
  /** Function to Add Other & Not Applicable option to the Dropdown value */
  const addValuesDropdown = (dropDownArr = [], type, shouldAddNOTAPPLICABLE = false) => {
    const OtherObj = dropDownArr?.find((item) => item.name === OTHER);
    if (!OtherObj && type !== ROLE) dropDownArr.push({ id: 'other', name: OTHER });
    const NOTAPPLICABLEObj = dropDownArr?.find((item) => item.name === NOTAPPLICABLE);
    if (!NOTAPPLICABLEObj && type !== ROLE && shouldAddNOTAPPLICABLE)
      dropDownArr.push(notApplicableObj);
    return dropDownArr;
  };
  /**Get dynamic selected value already saved */
  const getSelectedValueObjectFromList = (selectedValues, type) => {
    const SelectedValueObjectFromList = filterRecord?.records[`${type.toLowerCase()}`].find(
      (item) => item.name === selectedValues,
    );
    return SelectedValueObjectFromList || '';
  };
  /**Mapped with Filter value and set to autocomplete selected values */
  const setMapOfMultiSelectionValues = (params) => {
    let spltArr = [];
    if (params.additional_curriculla !== '') {
      spltArr = params.additional_curriculla?.split(',') || [];
      let mappedAdditonalCurriculla = [];
      if (spltArr.length > NUMBER_ARRAY.zero) {
        mappedAdditonalCurriculla = spltArr.map((mapItem) => {
          // Replace #_COMMA_# with ',' in additional curriculum name and then find from the array
          const curriculumName = mapItem.replace(/#_COMMA_#/g, ',');
          const res = filterRecord?.records.addnl_optional.find(
            (item) => item.name === curriculumName.trim(),
          );
          return res;
        });
        setSelectedAddnlOptionalCurriculla(mappedAdditonalCurriculla);
      } else {
        mappedAdditonalCurriculla = filterRecord?.records.addnl_optional.filter(
          (item) => item.name === params.additional_curriculla,
        );
        setSelectedAddnlOptionalCurriculla(mappedAdditonalCurriculla);
      }
    }
  };

  /**
   * @description execute logic for disable dropdown in case of OTHER selection.
   * @param {*} value
   * @param {*} indicator
   */
  const disableLogicForOtherType = (value, indicator) => {
    if (value === OTHER) {
      switch (indicator) {
        case ORGANIZATION:
          setDisableObj({
            ...disableObj,
            function: true,
            subFunction: true,
            specialization: true,
            subspecialization: true,
            role: true,
            WWIDMerger: true,
            additionalOptionalCurricula: true,
          });
          setSelectedFunction(NOTAPPLICABLE);
          setSelectedSubFunction(NOTAPPLICABLE);
          setSelectedSpecialization(NOTAPPLICABLE);
          setSelectedSubSpecialization(NOTAPPLICABLE);

          setIsWWIDMergerChecked(false);
          setOldWWID(NUMBER_ARRAY.zero);
          setInputOldWWIDError(false);
          setStartDate(null);
          break;
        case FUNCTION:
          setDisableObj({
            ...disableObj,
            subFunction: true,
            specialization: true,
            subspecialization: true,
            role: true,
            WWIDMerger: true,
            additionalOptionalCurricula: true,
          });
          setSelectedSubFunction(NOTAPPLICABLE);
          setSelectedSpecialization(NOTAPPLICABLE);
          setSelectedSubSpecialization(NOTAPPLICABLE);

          setIsWWIDMergerChecked(false);
          setOldWWID(NUMBER_ARRAY.zero);
          setInputOldWWIDError(false);
          setStartDate(null);
          break;
        case SUB_FUNCTION:
          setDisableObj({
            ...disableObj,
            specialization: true,
            subspecialization: true,
            role: true,
            WWIDMerger: true,
            additionalOptionalCurricula: true,
          });
          setSelectedSpecialization(NOTAPPLICABLE);
          setSelectedSubSpecialization(NOTAPPLICABLE);

          setIsWWIDMergerChecked(false);
          setOldWWID(NUMBER_ARRAY.zero);
          setInputOldWWIDError(false);
          setStartDate(null);
          break;
        case SPECIALIZATION:
          setDisableObj({
            ...disableObj,
            subspecialization: true,
            role: true,
            WWIDMerger: true,
            additionalOptionalCurricula: true,
          });
          setSelectedSubSpecialization(NOTAPPLICABLE);

          setIsWWIDMergerChecked(false);
          setOldWWID(NUMBER_ARRAY.zero);
          setInputOldWWIDError(false);
          setStartDate(null);
          break;
        case SUB_SPECIALIZATION:
          setDisableObj({
            ...disableObj,
            role: true,
            WWIDMerger: true,
            additionalOptionalCurricula: true,
          });

          setIsWWIDMergerChecked(false);
          setOldWWID(NUMBER_ARRAY.zero);
          setInputOldWWIDError(false);
          setStartDate(null);
          break;
        default:
          break;
      }
    } else if (value === NOTAPPLICABLE) {
      switch (indicator) {
        case FUNCTION:
          setDisableObj({
            ...disableObj,
            function: true,
            subFunction: true,
            specialization: true,
            subspecialization: true,
            role: false,
            WWIDMerger: false,
            additionalOptionalCurricula: false,
          });
          setSelectedSubFunction(NOTAPPLICABLE);
          setSelectedSpecialization(NOTAPPLICABLE);
          setSelectedSubSpecialization(NOTAPPLICABLE);
          break;
        case SUB_FUNCTION:
          setDisableObj({
            ...disableObj,
            subFunction: true,
            specialization: true,
            subspecialization: true,
            role: false,
            WWIDMerger: false,
            additionalOptionalCurricula: false,
          });
          setSelectedSpecialization(NOTAPPLICABLE);
          setSelectedSubSpecialization(NOTAPPLICABLE);
          break;
        case SPECIALIZATION:
          setDisableObj({
            ...disableObj,
            specialization: true,
            subspecialization: true,
            role: false,
            WWIDMerger: false,
            additionalOptionalCurricula: false,
          });
          setSelectedSubSpecialization(NOTAPPLICABLE);
          break;
        case SUB_SPECIALIZATION:
          setDisableObj({
            ...disableObj,
            subspecialization: true,
            role: false,
            WWIDMerger: false,
            additionalOptionalCurricula: false,
          });
          break;
        default:
          break;
      }
    } else {
      setDisableObj({
        function: false,
        subFunction: indicator === ROLE ? disableObj.subFunction : false,
        specialization: indicator === ROLE ? disableObj.specialization : false,
        subspecialization: indicator === ROLE ? disableObj.subspecialization : false,
        role: false,
        additionalInformation: false,
      });
    }
  };

  /**
   * @description Reset the dropdown in case of OTHER and Value Change.
   * @param {*} indicator
   */
  const resetDependentDropdownValue = (indicator) => {
    switch (indicator) {
      case ORGANIZATION:
        setSelectedFunction('');
        setSelectedSubFunction('');
        setSelectedSpecialization('');
        setSelectedSubSpecialization('');
        setSelectedRole('');
        setSelectedAddnlOptionalCurriculla([]);
        break;
      case FUNCTION:
        setSelectedSubFunction('');
        setSelectedSpecialization('');
        setSelectedSubSpecialization('');
        setSelectedRole('');
        setSelectedAddnlOptionalCurriculla([]);
        break;
      case SUB_FUNCTION:
        setSelectedSpecialization('');
        setSelectedSubSpecialization('');
        setSelectedRole('');
        setSelectedAddnlOptionalCurriculla([]);
        break;
      case SPECIALIZATION:
        setSelectedSubSpecialization('');
        setSelectedRole('');
        setSelectedAddnlOptionalCurriculla([]);
        break;
      case SUB_SPECIALIZATION:
        setSelectedRole('');
        setSelectedAddnlOptionalCurriculla([]);
        break;
      case ROLE:
        break;
      default:
        break;
    }
  };

  const requiredFieldValidation = () => {
    if (
      selectedOrganization === '' ||
      (isDatePickerShow &&
        selectedDateRange[NUMBER_ARRAY.zero] === null &&
        selectedDateRange[NUMBER_ARRAY.one] === null) ||
      (selectedFunction !== OTHER &&
        selectedFunction !== NOTAPPLICABLE &&
        selectedSubFunction !== OTHER &&
        selectedSubFunction !== NOTAPPLICABLE &&
        selectedSpecialization !== OTHER &&
        selectedSpecialization !== NOTAPPLICABLE &&
        selectedSubSpecialization !== OTHER &&
        selectedSubSpecialization !== NOTAPPLICABLE &&
        (selectedFunction === '' ||
          selectedSubFunction === '' ||
          selectedSpecialization === '' ||
          selectedSubSpecialization === '')) ||
      (filterRecord?.records &&
        filterRecord?.records?.role?.length > NUMBER_ARRAY.zero &&
        selectedRole === '' &&
        !(
          selectedFunction === OTHER ||
          selectedSubFunction === OTHER ||
          selectedSpecialization === OTHER ||
          selectedSubSpecialization === OTHER
        )) ||
      filterRecord?.records?.role?.length === NUMBER_ARRAY.zero ||
      otherAdditionalImformation ||
      (isWWIDMergerChecked && (oldWWID === null || startDate === null))
    ) {
      return true;
    } else {
      return false;
    }
  };

  const dirtyCheckDateRange = () => {
    let date = [params?.leave_start_date, params?.leave_end_date];
    const dateParentFormatted = date.map((date) => dayjs(date));
    date = dateParentFormatted.map((date) => date.format('YYYY-MM-DD'));
    const selectedDateParentFormat = selectedDateRange.map((date) => dayjs(date));
    const selectedDateRangeFormatted = selectedDateParentFormat.map((date) =>
      date.format('YYYY-MM-DD'),
    );

    return (
      isDatePickerShow === (params?.leave_of_absence === 'Y') &&
      date.some((item) => selectedDateRangeFormatted.includes(item))
    );
  };

  const dirtyCheckForSave = () => {
    if (
      (params?.organization === selectedOrganization &&
        params?.function === selectedFunction &&
        params?.sub_function === selectedSubFunction &&
        params?.specialization === selectedSpecialization &&
        params?.sub_specialization === selectedSubSpecialization &&
        params?.job_role === selectedRole &&
        params?.remarks === remarkDescription &&
        params?.old_wwid == oldWWID &&
        params?.addnl_optional === selectedAddnlOptionalCurriculla &&
        params?.start_date === startDate &&
        dirtyCheckDateRange()) ||
      inputOldWWIDError
    ) {
      return true;
    } else {
      return false;
    }
  };

  const onDateRangeChange = (event, type) => {
    if (type === 'Date') {
      if (event?.length && event[NUMBER_ARRAY.zero]?.length) {
        const dateRangeParentFormatted = event ? event.map((date) => dayjs(date)) : null;
        const dateFormatted =
          dateRangeParentFormatted?.map((date) => date.format('YYYY-MM-DD')) ?? [];
        setSelectedDateRange(dateFormatted);
        setSelectedDate(dateRangeParentFormatted);
      } else {
        setSelectedDate([]);
        event[NUMBER_ARRAY.zero] = null;
        event[NUMBER_ARRAY.zero] = null;
        setSelectedDateRange(event);
      }
    }
  };

  const handleTextArea = (newValue) => {
    if (newValue.length > NUMBER_ARRAY.twoFifty) {
      newValue = newValue.substring(NUMBER_ARRAY.zero, NUMBER_ARRAY.twoFifty);
    }
    if (!INPUT_FIELD_TEXT_AREA_OTHER_VAL_REGEX.test(newValue)) {
      setInputRemarkError(true);
    } else {
      setInputRemarkError(false);
    }
    setRemarkDescription(newValue);
  };

  const handleOldWWID = (value) => {
    if (value !== null && INPUT_FILD_WWID_REGEX.test(value)) {
      if (value === params?.user_id) {
        setInputOldWWIDError(true);
      } else {
        setInputOldWWIDError(false);
      }
      setOldWWID(value);
    } else {
      setInputOldWWIDError(false);
    }
  };

  const handleCheckChange = () => {
    setIsWWIDMergerChecked((prevChecked) => !prevChecked);
  };

  const switchChange = (_e, type) => {
    if (type === ADHOCCURRICULA) {
      setIsAdhocCurriculaSwitchOn(!isAdhocCurriculaSwitchOn);
      setAdhocCurricullaChecked(!adhocCurricullaChecked);
    } else if (type === ADDITIONALOPTIONALCURRICULLA) {
      setIsAdditonalOptionalCurriculaSwitchOn(!isAdditonalOptionalCurriculaSwitchOn);
      setAdditionalOptionalCurricullaChecked(!additionalOptionalCurricullaChecked);
    }
  };

  const getLabeledOptions = (option, type) => {
    if (type === ADHOCCURRICULA) {
      return `${option.name}`;
    } else if (type === ADDITIONALOPTIONALCURRICULLA) {
      return `${option?.name}`;
    }
  };

  const getEqualityCheck = (option, value, type) => {
    if (type === ADHOCCURRICULA) {
      return value && option.id === value.id;
    } else if (type === ADDITIONALOPTIONALCURRICULLA) {
      return value && option.id === value.id;
    }
  };

  useEffect(() => {
    if (!isWWIDMergerChecked) {
      setStartDate(null);
      setOldWWID(NUMBER_ARRAY.zero);
    }
  }, [isWWIDMergerChecked]);

  useEffect(() => {
    if (filterRecord !== undefined && params !== undefined && changedDropdownName === 'preload') {
      setMapOfMultiSelectionValues(params);
    }
  }, [filterRecord, params, changedDropdownName]);

  useEffect(() => {
    setIsDatePickerShow(params?.leave_of_absence === 'Y');
    setSelectedDateRange([params?.leave_start_date, params?.leave_end_date]);
    setSelectedOrganization(params?.organization);
    setSelectedOrganizationDirty(false);

    setSelectedFunction(
      params?.function === OTHER || params?.function === '' ? NOTAPPLICABLE : params?.function,
    );
    setSelectedSubFunction(
      params?.sub_function === OTHER || params?.sub_function === ''
        ? NOTAPPLICABLE
        : params?.sub_function,
    );
    setSelectedSpecialization(
      params?.specialization === OTHER || params?.specialization === ''
        ? NOTAPPLICABLE
        : params?.specialization,
    );
    setSelectedSubSpecialization(
      params?.sub_specialization === OTHER || params?.sub_specialization === ''
        ? NOTAPPLICABLE
        : params?.sub_specialization,
    );
    setSelectedRole(params?.job_role);
    setRemarkDescription(params?.remarks);
    setDisableObj({
      ...disableObj,
      function: params?.function === OTHER || params?.function === '',
      subFunction:
        params?.subFunction === OTHER ||
        params?.subFunction === '' ||
        params?.function === OTHER ||
        params?.function === '',
      specialization:
        params?.specialization === OTHER ||
        params?.specialization === '' ||
        params?.subFunction === OTHER ||
        params?.subFunction === '',
      subspecialization:
        params?.subspecialization === OTHER ||
        params?.subspecialization === '' ||
        params?.specialization === OTHER ||
        params?.specialization === '',
    });

    setOldWWID(params?.old_wwid);
    setStartDate(params?.start_date);
    if (params?.old_wwid || params?.start_date) {
      setIsWWIDMergerChecked(true);
    }
    setChangedDropdownName('preload');
  }, [params]);

  useEffect(() => {
    /**set this value in every cross click or input type change on autocomplete */
    if (
      selectedFunction === OTHER ||
      selectedSubFunction === OTHER ||
      selectedSpecialization === OTHER ||
      selectedSubSpecialization === OTHER
    ) {
      setOtherText(OTHER);
    } else {
      setOtherText('');
    }
    /**Disable logic */
    if (selectedFunction === OTHER) {
      disableLogicForOtherType(OTHER, FUNCTION);
    } else if (
      selectedFunction === '' &&
      confirmAutoCompleteSingleSelectionSelectedvalue(
        selectedFunction,
        FUNCTION,
        selectedOrganization,
      )
    ) {
      disableLogicForOtherType(NOTAPPLICABLE, FUNCTION);
    }
    //
    if (
      filterRecord?.records?.function?.length === NUMBER_ARRAY.zero ||
      (selectedFunction === '' &&
        (changedDropdownName !== '' || changedDropdownName !== 'preload') &&
        otherText === OTHER &&
        filterRecord?.records?.function?.filter((item) => item.name !== OTHER)?.length ===
          NUMBER_ARRAY.zero) ||
      (otherText === '' &&
        filterRecord?.records?.function?.filter(
          (item) => item.name !== OTHER && item.name !== NOTAPPLICABLE,
        )?.length === NUMBER_ARRAY.zero)
    ) {
      setSelectedFunction(NOTAPPLICABLE);
    } else {
      // setSelectedFunction('');
    }

    if (selectedSubFunction === OTHER) {
      disableLogicForOtherType(OTHER, SUB_FUNCTION);
    } else if (
      selectedSubFunction === '' &&
      confirmAutoCompleteSingleSelectionSelectedvalue(
        selectedSubFunction,
        SUB_FUNCTION,
        selectedOrganization,
      )
    ) {
      disableLogicForOtherType(NOTAPPLICABLE, SUB_FUNCTION);
    }
    //
    if (
      changedDropdownName !== FUNCTION &&
      selectedFunction !== '' &&
      (filterRecord?.records?.sub_function?.length === NUMBER_ARRAY.zero ||
        (selectedSubFunction === '' &&
          (changedDropdownName !== '' || changedDropdownName !== 'preload') &&
          otherText === OTHER &&
          filterRecord?.records?.sub_function?.filter((item) => item.name !== OTHER)?.length ===
            NUMBER_ARRAY.zero) ||
        (otherText === '' &&
          filterRecord?.records?.sub_function?.filter(
            (item) => item.name !== OTHER && item.name !== NOTAPPLICABLE,
          )?.length === NUMBER_ARRAY.zero))
    ) {
      setSelectedSubFunction(NOTAPPLICABLE);
    } else {
      // setSelectedSubFunction('');
    }

    if (selectedSpecialization === OTHER) {
      disableLogicForOtherType(OTHER, SPECIALIZATION);
    } else if (
      selectedSpecialization === '' &&
      confirmAutoCompleteSingleSelectionSelectedvalue(
        selectedSpecialization,
        SPECIALIZATION,
        selectedOrganization,
      )
    ) {
      disableLogicForOtherType(NOTAPPLICABLE, SPECIALIZATION);
    }
    //
    if (
      (changedDropdownName !== SUB_FUNCTION &&
        selectedSubFunction !== '' &&
        filterRecord?.records?.specialization?.length === NUMBER_ARRAY.zero) ||
      (((selectedSpecialization === '' && changedDropdownName !== '') ||
        changedDropdownName !== 'preload') &&
        otherText === OTHER &&
        filterRecord?.records?.specialization?.filter((item) => item.name !== OTHER)?.length ===
          NUMBER_ARRAY.zero) ||
      (otherText === '' &&
        filterRecord?.records?.specialization?.filter(
          (item) => item.name !== OTHER && item.name !== NOTAPPLICABLE,
        )?.length === NUMBER_ARRAY.zero)
    ) {
      setSelectedSpecialization(NOTAPPLICABLE);
    } else {
      // setSelectedSpecialization('');
    }

    if (selectedSubSpecialization === OTHER) {
      disableLogicForOtherType(OTHER, SUB_SPECIALIZATION);
    } else if (
      selectedSubSpecialization === '' &&
      confirmAutoCompleteSingleSelectionSelectedvalue(
        selectedSubSpecialization,
        SUB_SPECIALIZATION,
        selectedOrganization,
      )
    ) {
      disableLogicForOtherType(NOTAPPLICABLE, SUB_SPECIALIZATION);
    }
    //
    if (
      changedDropdownName !== SPECIALIZATION &&
      selectedSpecialization !== '' &&
      (filterRecord?.records?.sub_specialization?.length === NUMBER_ARRAY.zero ||
        (((selectedSubSpecialization === '' && changedDropdownName !== '') ||
          changedDropdownName !== 'preload') &&
          otherText === OTHER &&
          filterRecord?.records?.sub_specialization?.filter((item) => item.name !== OTHER)
            ?.length === NUMBER_ARRAY.zero) ||
        (otherText === '' &&
          filterRecord?.records?.sub_specialization?.filter(
            (item) => item.name !== OTHER && item.name !== NOTAPPLICABLE,
          )?.length === NUMBER_ARRAY.zero))
    ) {
      setSelectedSubSpecialization(NOTAPPLICABLE);
    } else {
      // setSelectedSubSpecialization('');
    }

    setDisableObj({
      ...disableObj,
      function:
        selectedFunction === OTHER ||
        selectedFunction === NOTAPPLICABLE ||
        ((changedDropdownName !== '' || changedDropdownName !== 'preload') &&
          filterRecord?.records?.function?.filter(
            (item) => item.name !== OTHER && item.name !== NOTAPPLICABLE,
          )?.length === NUMBER_ARRAY.zero),
      subFunction:
        selectedSubFunction === OTHER ||
        selectedSubFunction === NOTAPPLICABLE ||
        ((changedDropdownName !== '' || changedDropdownName !== 'preload') &&
          filterRecord?.records?.sub_function?.filter(
            (item) => item.name !== OTHER && item.name !== NOTAPPLICABLE,
          )?.length === NUMBER_ARRAY.zero) ||
        selectedFunction === OTHER ||
        selectedFunction === NOTAPPLICABLE,
      specialization:
        selectedSpecialization === OTHER ||
        selectedSpecialization === NOTAPPLICABLE ||
        ((changedDropdownName !== '') | (changedDropdownName !== 'preload') &&
          filterRecord?.records?.specialization?.filter(
            (item) => item.name !== OTHER && item.name !== NOTAPPLICABLE,
          )?.length === NUMBER_ARRAY.zero) ||
        selectedSubFunction === OTHER ||
        selectedSubFunction === NOTAPPLICABLE,
      subspecialization:
        selectedSubSpecialization === OTHER ||
        selectedSubSpecialization === NOTAPPLICABLE ||
        ((changedDropdownName !== '' || changedDropdownName !== 'preload') &&
          filterRecord?.records?.sub_specialization?.filter(
            (item) => item.name !== OTHER && item.name !== NOTAPPLICABLE,
          )?.length === NUMBER_ARRAY.zero) ||
        selectedSpecialization === OTHER ||
        selectedSpecialization === NOTAPPLICABLE,
    });
  }, [
    otherText,
    filterRecord,
    changedDropdownName,
    selectedFunction,
    selectedSubFunction,
    selectedSpecialization,
    selectedSubSpecialization,
  ]);

  useEffect(() => {
    if (startDate) {
      const dateParentFormatted = dayjs(startDate);
      setSelectedStartDate(dateParentFormatted);
    } else {
      setSelectedStartDate(startDate);
    }
  }, [startDate]);

  useEffect(() => {
    if (selectedDateRange.length > 1 && !selectedDateRange.includes(null)) {
      const dateRangeParentFormatted = selectedDateRange
        ? selectedDateRange.map((date) => dayjs(date))
        : null;
      setSelectedDate(dateRangeParentFormatted);
    }
  }, [selectedDateRange]);

  useEffect(() => {
    if (otherText === OTHER && remarkDescription === '') {
      setOtherAdditionalImformation(true);
    } else {
      setOtherAdditionalImformation(false);
    }
  }, [isOtherSelected, remarkDescription]);

  useEffect(() => {
    if (
      changedDropdownName === 'preload' ||
      (changedDropdownName === ORGANIZATION &&
        selectedOrganization !== OTHER &&
        selectedOrganization !== NOTAPPLICABLE) ||
      (changedDropdownName === FUNCTION &&
        selectedFunction !== OTHER &&
        selectedFunction !== NOTAPPLICABLE) ||
      (changedDropdownName === SUB_FUNCTION &&
        selectedSubFunction !== OTHER &&
        selectedSubFunction !== NOTAPPLICABLE) ||
      (changedDropdownName === SPECIALIZATION &&
        selectedSpecialization !== OTHER &&
        selectedSpecialization !== NOTAPPLICABLE) ||
      (changedDropdownName === SUB_SPECIALIZATION &&
        selectedSubSpecialization !== OTHER &&
        selectedSubSpecialization !== NOTAPPLICABLE) ||
      (changedDropdownName === ROLE && selectedRole !== OTHER && selectedRole !== NOTAPPLICABLE)
    ) {
      dispatch(
        MyTeamProfilePopUpFilter(
          createFilterPayload(
            selectedOrganization,
            selectedFunction,
            selectedSubFunction,
            selectedSpecialization,
            selectedSubSpecialization,
            selectedRole,
          ),
        ),
      );
    }
  }, [
    changedDropdownName,
    selectedOrganization,
    selectedFunction,
    selectedSubFunction,
    selectedSpecialization,
    selectedSubSpecialization,
    selectedRole,
  ]);

  useEffect(() => {
    if (
      selectedOrganization !== '' ||
      selectedFunction !== '' ||
      selectedSubFunction !== '' ||
      selectedSpecialization !== '' ||
      selectedSubSpecialization !== '' ||
      selectedAddnlOptionalCurriculla.length !== NUMBER_ARRAY.zero ||
      selectedRole !== '' ||
      selectedDateRange.length === NUMBER_ARRAY.zero ||
      oldWWID !== null ||
      remarkDescription !== '' ||
      selectedDateRange.length !== 0 ||
      (startDate && startDate !== null) ||
      otherAdditionalImformation
    ) {
      const savePayload = createSavePopUpPayload();
      const reuiredFieldValidation = requiredFieldValidation();
      const isSaveDisabled = dirtyCheckForSave();
      saveCallBack(savePayload, isSaveDisabled, reuiredFieldValidation);
    }
  }, [
    selectedOrganization,
    selectedFunction,
    selectedSubFunction,
    selectedSpecialization,
    selectedSubSpecialization,
    selectedRole,
    selectedAddnlOptionalCurriculla,
    isDatePickerShow,
    remarkDescription,
    oldWWID,
    startDate,
    otherAdditionalImformation,
    selectedDateRange,
    isWWIDMergerChecked,
  ]);

  const [expanded, setExpanded] = React.useState(false); // For managing Cirrcula Accordion expansion
  const handleRequiredCurriculaAccChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Fragment>
      <Box className='pop-up-user-profile'>
        <Grid container>
          {isOtherSelected && (
            <Grid item md={12} className='other-warning-toaster'>
              <Toaster
                onClose={() => setIsOtherSelected(false)}
                vertical={'top'}
                severity={'warn'}
                show={isOtherSelected && changedDropdownName !== 'preload'}
                message={TapGlobalMessages.userGroupProfile.otherChoosenMessage}
              />
            </Grid>
          )}
          <Grid item xs={6} sm={4} md={3}>
            <Typography sx={labelTypoGraphyStyle}>{'Job Title:'}</Typography>
            <Typography sx={labelDataStyle}>{params.job_title || NO_DATA_DAS}</Typography>
          </Grid>
          <Grid item xs={6} sm={4} md={3}>
            <Typography sx={labelTypoGraphyStyle}>{'Worker Type:'}</Typography>
            <Typography sx={labelDataStyle}>{params.worker_type || NO_DATA_DAS}</Typography>
          </Grid>
          <Grid item xs={6} sm={4} md={3}>
            <Typography sx={labelTypoGraphyStyle}>{'Partner Company:'}</Typography>
            <Typography sx={labelDataStyle}>{params.partner_company || NO_DATA_DAS}</Typography>
          </Grid>
          <Grid item xs={6} sm={4} md={3}>
            <Typography sx={labelTypoGraphyStyle}>{'Country:'}</Typography>
            <Typography sx={labelDataStyle}>{params.country_name || NO_DATA_DAS}</Typography>
          </Grid>
        </Grid>
        <Divider sx={{ marginTop: '12px', marginBottom: '12px' }} />
      </Box>
      {filterRecord && (
        <Box className='pop-up-user-profile'>
          <Grid container spacing={2}>
            <Grid
              sx={{ display: 'flex', flexDirection: 'row', paddingTop: '25px', gap: '43px' }}
              item
              xs={12}
              sm={12}
              md={6}
            >
              <Stack direction={'column'} gap={'5px'} sx={{ marginTop: '15px' }}>
                <Stack>
                  <InputLabel
                    sx={{
                      ...inputLabelStyle,
                      color: theme.palette.text.primary,
                      height: '18px !important',
                    }}
                    variant='standard'
                  >
                    {'On Leave'}
                  </InputLabel>
                </Stack>
                <Stack direction={'row'}>
                  <IOSSwitch
                    id='onLeave'
                    data-testid='onleave'
                    checked={isDatePickerShow}
                    onChange={() => setIsDatePickerShow(!isDatePickerShow)}
                  />
                  <Typography>{'Yes'}</Typography>
                </Stack>
              </Stack>
              {isDatePickerShow && (
                <Stack display={'flex'} marginTop={'15px'}>
                  <Stack direction={'column'}>
                    <Stack direction={'row'} gap={'10px'}>
                      <InputLabel
                        sx={{
                          ...inputLabelStyle,
                          color: theme.palette.text.primary,
                          height: '18px !important',
                        }}
                      >
                        {'Leave Date Range'}
                      </InputLabel>
                      {genericHelpIcon(
                        TapGlobalMessages?.userGroupProfile?.myProfile?.toolTip?.leaveOfAbsence,
                        false,
                        '18px !important',
                        '18px !important',
                      )}
                    </Stack>
                    <DateRangePicker
                      height={'33px'}
                      onChange={(e) => onDateRangeChange(e, DATE)}
                      marginTop={'0px'}
                      padding={'4px, 0px'}
                      value={selectedDate}
                    />
                  </Stack>
                </Stack>
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={6}>
              {autoCompleteSingleSelection(
                filterRecord.records.organization,
                selectedOrganization,
                ORGANIZATION,
                'Organization',
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={6}>
              {autoCompleteSingleSelection(
                filterRecord.records.function,
                selectedFunction,
                FUNCTION,
                'Function',
                disableObj.function,
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={6}>
              {autoCompleteSingleSelection(
                filterRecord.records.sub_function,
                selectedSubFunction,
                SUB_FUNCTION,
                'Sub Function',
                disableObj.subFunction,
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={6}>
              {autoCompleteSingleSelection(
                filterRecord.records.specialization,
                selectedSpecialization,
                SPECIALIZATION,
                'Specialization',
                disableObj.specialization,
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={6}>
              {autoCompleteSingleSelection(
                filterRecord.records.sub_specialization,
                selectedSubSpecialization,
                SUB_SPECIALIZATION,
                'Sub Specialization',
                disableObj.subspecialization,
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={6}>
              {autoCompleteSingleSelection(
                filterRecord.records.role,
                selectedRole,
                ROLE,
                'Role',
                disableObj.role,
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <GenericAutoCompleteUserProfile
                options={filterRecord.records.addnl_optional}
                values={selectedAddnlOptionalCurriculla}
                switchChangeHandler={switchChange}
                checked={additionalOptionalCurricullaChecked}
                getLabeledOptions={getLabeledOptions}
                getEqualityCheck={getEqualityCheck}
                type={ADDITIONALOPTIONALCURRICULLA}
                placeholder={
                  selectedAddnlOptionalCurriculla?.length
                    ? `${selectedAddnlOptionalCurriculla.length} ${TapGlobalMessages.userGroupProfile.myTeamProfile.selected}`
                    : `${TapGlobalMessages.userGroupProfile.myTeamProfile.search}`
                }
                heading={`Additional/Optional Curricula`}
                switchIndicator={isAdditonalOptionalCurriculaSwitchOn}
                isSwitchToShow={true}
                handleAutoCompleteChange={handleAutoCompleteChange}
                inputWidth={'416px'}
                isDisabled={disableObj?.additionalOptionalCurricula}
              />
            </Grid>
            {/* WWID Merger Section */}
            <Grid item xs={12} sm={4} md={6} sx={{ paddingLeft: '5px !important' }}>
              <Grid item xs={12} sm={4} md={6}>
                <Stack direction={'row'} alignItems='center'>
                  <Checkbox
                    disabled={disableObj.WWIDMerger}
                    checked={isWWIDMergerChecked}
                    onChange={handleCheckChange}
                  />
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 500,
                      fontFamily: '"JohnsonText-Regular"',
                      color: disableObj.WWIDMerger
                        ? theme.palette.fontColor.light_gray
                        : theme.palette.text.primary,
                      height: screen.isTablet ? '22px' : '16px',
                      paddingTop: screen.isTablet ? '3px' : NUMBER_ARRAY.zero,
                      lineHeight: 'unset',
                    }}
                  >
                    Merge WWID
                  </Typography>
                  {!disableObj.WWIDMerger && (
                    <Stack
                      sx={{ height: '12px', width: '12px', marginLeft: '5px', marginTop: '-3px' }}
                    >
                      {genericHelpIcon(
                        TapGlobalMessages?.userGroupProfile?.myProfile?.toolTip?.MergeWWID,
                        false,
                        '18px !important',
                        '18px !important',
                      )}
                    </Stack>
                  )}
                </Stack>
              </Grid>
              {isWWIDMergerChecked && (
                <Grid item sx={{ marginLeft: '12px' }}>
                  <Stack
                    direction={'column'}
                    spacing={1}
                    sx={{
                      width: '100%',
                    }}
                  >
                    <Grid flex={1}>
                      <InputLabel
                        sx={{
                          fontSize: '14px',
                          fontWeight: 500,
                          fontFamily: '"JohnsonText-Regular"',
                          color: theme.palette.text.primary,
                          height: screen.isTablet ? '22px' : '16px',
                          paddingTop: screen.isTablet ? '3px' : NUMBER_ARRAY.zero,
                          lineHeight: 'unset',
                        }}
                      >
                        Old WWID*
                      </InputLabel>
                      <TextField
                        size='small'
                        value={oldWWID === 0 ? '' : oldWWID}
                        onChange={(e) => handleOldWWID(e.target.value)}
                        placeholder='Enter WWID'
                        padding='0px'
                        fullWidth
                        helperText={inputOldWWIDError ? `Entered WWID is same for new WWID` : ''}
                        sx={{
                          marginTop: '2px',
                        }}
                      />
                    </Grid>
                    <Grid flex={1}>
                      <InputLabel
                        sx={{
                          fontSize: '14px',
                          fontWeight: 500,
                          fontFamily: '"JohnsonText-Regular"',
                          color: theme.palette.text.primary,
                          height: screen.isTablet ? '22px' : '16px',
                          paddingTop: screen.isTablet ? '3px' : NUMBER_ARRAY.zero,
                          lineHeight: 'unset',
                        }}
                      >
                        New WWID Start Date*
                      </InputLabel>
                      <SingleDatePicker
                        style={{ width: '100%' }}
                        format='DD-MMM-YYYY'
                        placeholder='DD-MMM-YYYY'
                        size='small'
                        value={selectedstartDate}
                        onChange={(dateObj) => {
                          const formattedDate = dateObj
                            ? dayjs(dateObj).format('DD-MMM-YYYY')
                            : null;
                          setStartDate(formattedDate);
                        }}
                        allowClear
                      />
                    </Grid>
                  </Stack>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={6}>
              <GenericCustomTextArea
                headerText='Additional Information'
                value={remarkDescription}
                handleTextChange={(value) => handleTextArea(value)}
                borderStyles={{
                  borderRadius: '8px',
                }}
                RequiredField={true}
                isDisable={disableObj.additionalInformation}
                rows={4}
                maxRows={10}
                marginTop='20px'
                characterLimit={NUMBER_ARRAY.twoFifty}
                inputNameError={inputRemarkError}
                inputErrorMessage={labels.validationErrorMessage}
                height='100px'
                enableTooltip={otherText === OTHER}
                tooltipTittle={
                  TapGlobalMessages?.userGroupProfile?.myProfile?.toolTip?.additionalInformation
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              {selectedRole !== '' &&
              filterRecord?.records &&
              filterRecord?.records?.required_curricula?.length > NUMBER_ARRAY.zero ? (
                <Accordion
                  expanded={expanded === 'required-curricula-panel'}
                  onChange={handleRequiredCurriculaAccChange('required-curricula-panel')}
                  sx={{ boxShadow: 'none' }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon sx={{ color: theme.palette.curricula_close_white }} />
                    }
                    id='required-curricula-panel-header'
                    sx={{
                      background: theme.palette.curricula_red,
                      color: theme.palette.curricula_close_white,
                      borderRadius: '22px',
                      minHeight: '44px !important',
                      '&.Mui-expanded': {
                        borderRadius: '22px 22px 0 0 ',
                      },
                      '.MuiAccordionSummary-content': {
                        margin: '8px 0 !important',
                      },
                    }}
                  >
                    <Typography sx={{ fontSize: '14px', fontWeight: '500', lineHeight: '12px' }}>
                      {
                        TapGlobalMessages?.userGroupProfile?.myTeamProfile
                          ?.requiredCurriculaHeadingText
                      }
                      <Typography
                        sx={{ fontSize: '10px', display: 'block', paddingTop: '10px' }}
                        component='span'
                      >
                        {filterRecord?.records?.required_curricula?.length}{' '}
                        {
                          TapGlobalMessages?.userGroupProfile?.myTeamProfile
                            ?.requiredCurriculaCountText
                        }
                      </Typography>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      padding: '0',
                    }}
                  >
                    {filterRecord?.records?.required_curricula?.map((required_curr) => {
                      return (
                        <Typography
                          key={`required_curricula_${required_curr?.name}`}
                          sx={{
                            fontSize: '14px',
                            fontWeight: '400',
                            lineHeight: '16px',
                            color: theme.palette.text.primary,
                            borderBottom: `1px solid ${theme.palette.border}`,
                            padding: '6px 0 8px 12px',
                          }}
                        >
                          {required_curr?.name}
                        </Typography>
                      );
                    })}
                  </AccordionDetails>
                </Accordion>
              ) : (
                <Accordion
                  expanded={expanded === 'required-curricula-panel'}
                  onChange={handleRequiredCurriculaAccChange('required-curricula-panel')}
                  sx={{ boxShadow: 'none', borderRadius: '8px !important' }}
                  disabled={true}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.curricula_white }} />}
                    id='required-curricula-panel-header'
                    sx={{
                      background: theme.palette.border,
                      color: theme.palette.curricula_white,
                      opacity: '1 !important',
                      minHeight: '28px !important',
                      '.MuiAccordionSummary-content': {
                        margin: '8px 0 !important',
                      },
                    }}
                  >
                    <Typography sx={{ fontSize: '14px', fontWeight: '500', lineHeight: '12px' }}>
                      {
                        TapGlobalMessages?.userGroupProfile?.myTeamProfile
                          ?.requiredCurriculaHeadingText
                      }
                    </Typography>
                  </AccordionSummary>
                </Accordion>
              )}
            </Grid>
          </Grid>
        </Box>
      )}
    </Fragment>
  );
};
